import React, { type ReactNode } from 'react';

import { AttachedIconWrapper } from './styles';

export interface AttachedIconProps {
    // TODO: This should be typed for SVG components.
    children: ReactNode;
    circle?: boolean;
}

export function AttachedIcon({ children, circle = false }: AttachedIconProps) {
    return (
        <AttachedIconWrapper $circle={circle} aria-hidden="true">
            {children}
        </AttachedIconWrapper>
    );
}
